import { render, staticRenderFns } from "./BulkImportTab.vue?vue&type=template&id=e206e24a&scoped=true"
import script from "./BulkImportTab.vue?vue&type=script&lang=js"
export * from "./BulkImportTab.vue?vue&type=script&lang=js"
import style0 from "./BulkImportTab.vue?vue&type=style&index=0&id=e206e24a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e206e24a",
  null
  
)

export default component.exports